import { FlashSaleSchema, FlashSaleType } from '~/lib/atom/types/flash-sale';

export const safeParseFlashSaleJSON = (flashSaleJSON: string | undefined) => {
  if (!flashSaleJSON) {
    return null;
  }

  const parsedFlashSale: unknown = JSON.parse(flashSaleJSON);

  if (!parsedFlashSale) {
    return null;
  }

  const safeParsedFlashSale = FlashSaleSchema.safeParse(parsedFlashSale);

  return safeParsedFlashSale;
};

export const checkFlashSaleIsActive = (flashSale: FlashSaleType) => {
  if (!flashSale.flashSaleStartDate || !flashSale.flashSaleEndDate) {
    return false;
  }

  const current = new Date();
  const startDate = flashSale.flashSaleStartDate;
  const endDate = flashSale.flashSaleEndDate;

  return startDate < current && current < endDate;
};
